<template>
  <div>
    <div id="service" v-if="is_pc">
      <el-dialog width="480px" :title="form.title === '聚合页' ? '' : form.title" :visible.sync="dialogFormVisible"
        class="dialog-class" :before-close="handleClose">
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item prop="user_name" label="姓名" :label-width="formLabelWidth">
            <el-input placeholder="请输入姓名" maxlength="4" v-model="form.user_name"></el-input>
          </el-form-item>
          <el-form-item prop="mobile" label="手机号" :label-width="formLabelWidth">
            <el-input placeholder="请输入手机号" maxlength="11" v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item prop="work_unit" label="单位" :label-width="formLabelWidth">
            <el-input placeholder="请输入单位" v-model="form.work_unit"></el-input>
          </el-form-item>
          <el-form-item label="您的需求" :label-width="formLabelWidth">
            <el-input placeholder="请输入" type="textarea" v-model="form.content"></el-input>
          </el-form-item>

        </el-form>
        <!-- <div class="phone">
        <div class="kefu">
          <p>客服电话：</p>
          <p class="kefu-phone">0571 86711325</p>
        </div>
        <div class="wechat-big">
          <div class="wechat">
            <p>微信客服：</p>
            <p class="kefu-phone">社汇小秘书</p>
          </div>
          <div>
            <img class="erweima" src="../../static/img/erweima.jpg" alt="" />
          </div>
          <div></div>
        </div>
      </div> -->
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel()">取 消</el-button>
          <el-button style="background: #35bdb2" type="primary" @click="sureClick('form')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog width="480px" :title="tipsType == 'Tip' ? '提示' : '提交成功'" :visible.sync="dialogTipsVisible"
        class="dialog-class dialog-tishi-class">
        <div class="code">
          <!-- <img :src="'https://dl.sosho.cn/goserver/tool/qrcode?content='+config.url" alt=""> -->
          <img class="qrcode" src="https://pics.usho.cn/20240904/1725415512.jpg" alt="">
        </div>
        <p style="margin-top:20px;">{{ tipsType == 'Tip' ? '微信扫一扫即可联系社汇小助手' : '微信扫一扫，关注 ' + this.config.name + ' 客服' }}
        </p>
        <!-- <p><a :href="this.config.url" download class="kefu-phone">下载二维码</a></p> -->
        <div slot="footer" class="dialog-footer">
          <el-button style="background: #35bdb2" type="primary" @click="dialogTipsVisible = false">好的</el-button>
        </div>
      </el-dialog>
      <!-- <Vcode :show="isShow" @success="codeSuccess" @close="codeClose" style="z-index: 99999;"/> -->
      <el-dialog width="480px" title="请输入验证码" :visible.sync="isShow" class="dialog-class" :before-close="codeClose">
        <div class="captchaBox">
          <img :src="'https://admin.sosho.cn/server/account/captcha?mobile=' + form.mobile" alt="">
          <input type="text" v-model="form.captcha">
          <div slot="footer" class="dialog-footer">
            <el-button @click="isShow = !isShow">取 消</el-button>
            <el-button style="background: #35bdb2" type="primary" @click="codeSuccess()">确 定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="!is_pc && dialogFormVisible">
      <div class="opacity"></div>
      <div class="form_content">
        <p>{{ form.title === '聚合页' ? '留言信息' : form.title }}</p>
        <div class="form_item">
          <span>姓名</span>
          <input v-model="form.user_name" type="text">
        </div>
        <div class="form_item">
          <span>手机号</span>
          <input v-model="form.mobile" type="text">
        </div>
        <div class="form_item">
          <span>单位</span>
          <input v-model="form.work_unit" type="text">
        </div>
        <div class="form_item1">
          <span>您的需求</span>
          <textarea v-model="form.content" type="text" />
        </div>
        <div class="footer_box">
          <div class="cencel" @click="dialogFormVisible = !dialogFormVisible">取消</div>
          <div class="sure" @click="handleSure">确定</div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import $ from "jquery";
// const host = "https://tapi.sosho.cn";
import Vcode from "vue-puzzle-vcode";
const host = "https://api.sosho.cn";
export default {
  components: {
    Vcode
  },
  data() {
    return {
      isShow: false,
      config: {
      },
      dialogFormVisible: false,
      dialogTipsVisible: false,
      dialogTableVisible: false,
      form: {
        user_name: "",
        mobile: "",
        content: "",
        title: "",
      },
      formLabelWidth: "120px",
      is_pc: true,
      rules: {
        user_name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        work_unit: [
          { required: true, message: "请输入单位", trigger: "blur" },
        ],
      },
      tipsType: "Tip",
      server: '王先生',
    }
  },
  created() {
    this.isMobile();
  },
  watch: {
    "form.mobile": {
      handler(newVal) {
        if (!newVal) {
          this.form.mobile = ''
          return false
        }
        this.form.mobile = newVal.match(/\d/gi) ? newVal.match(/\d/gi).join('') : ''
      },
      deep: true,
    },
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    cancel() {
      this.dialogFormVisible = false;
      this.tipsType = 'Tip';
      this.dialogTipsVisible = true;
      this.$nextTick(() => {
        this.creatQrCode();
      })
    },
    isMobile() {
      var system = { win: false, mac: false, xll: false };
      var p = navigator.platform;
      system.win = p.indexOf("Win") == 0;
      system.mac = p.indexOf("Mac") == 0;
      system.x11 = (p == "X11") || (p.indexOf("Linux") == 0);
      if (system.win || system.mac || system.xll) {
        this.is_pc = true;
      } else {
        this.is_pc = false;
      }
    },
    creatQrCode() {
      $('#qrCodeUrl').text('');
      var doms = document.getElementById('qrCodeUrl');
      $.ajax({
        type: "GET",
        url: host + "/operate/wxwork_customer_service?appkey=h5",
        success: (dataIn) => {
          if (dataIn.items.length > 0) {
            this.config = dataIn.items[0];
            console.log(this.config);
          }
        }
      })
    },
    handleClose(done) {
      this.dialogFormVisible = false;
      this.dialogTipsVisible = true;
      this.tipsType = 'Tip';
      this.$nextTick(() => {
        this.creatQrCode();
      })
    },
    xcxClick(title) {
      this.form = {
        user_name: "",
        mobile: "",
        content: "",
        title: "",
        work_unit: '',
      };
      this.form.title = title;
      this.dialogFormVisible = true;
    },
    sureClick(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var pattern = /^[\u0391-\uFFE5]+$/;
          if (!this.form.user_name) {
            alert("请输入姓名")
            return;
          } else {
            this.form.user_name.replace(/[^\u4E00-\u9FA5]/g, '')
            if (!pattern.test(this.form.user_name)) {
              alert("请输入正确姓名")
              return;
            }
          }
          if (!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
            alert("请输入正确的手机号")
            return;
          }
          this.isShow = true;
        }
      });
    },
    handleSure() {
      if(!this.form.user_name) {
        alert("请输入姓名");
        return;
      } else if(!this.form.mobile) {
        alert("请输入手机号");
        return;
      } else if(!/^1[3456789]\d{9}$/.test(this.form.mobile)) {
        alert("请输入正确的手机号");
        return;
      } else if(!this.form.work_unit) {
        alert("请输入您的单位");
        return;
      } else {
        this.codeSuccess()
      }
    },
    codeSuccess() {
      $.ajax({
        type: "POST",
        url: host + "/saas/consult",
        data: {
          user_name: this.form.user_name,
          mobile: this.form.mobile,
          content: this.form.content,
          work_unit: this.form.work_unit,
          product_name: this.form.title,
          captcha: this.form.captcha,
          com_name: this.form.work_unit || "社汇官网",
          keyword: `${this.is_pc ? 'PC端官网' : 'H5端官网'}${this.form.title}获取解决方案` ,
        },
        headers: {
          appkey: "pwsite",
        },
        success: (dataIn) => {
          this.isShow = false;
          if (dataIn.errno == 0) {
            this.tipsType = 'success';
            this.dialogFormVisible = false;
            this.dialogTipsVisible = true;
            this.$nextTick(() => {
              this.creatQrCode();
            })
          } else {
            alert(dataIn.result.message)
          }

          // if(dataIn.errno == 0){
          //     this.$message({
          //         message: '短信验证码已发送，请注意接收',
          //         type: 'success'
          //     });
          //     this.centerDialogVisible = false;
          //     localStorage.setItem('getImgCodeTime', Date.now())
          // }else{
          //     this.$message.error(dataIn.errmsg);
          // }
        },
      });

    },
    codeClose() {
      this.isShow = false;
      this.form.captcha = '';
    },
  },
}
</script>

<style lang="less" scoped>
#service {
  width: 100%;
  height: 100%;

  .captchaBox {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 50%;
    }

    input {
      width: 50%;
      height: 30px;
      margin-bottom: 10px;
      padding: 5px;
      border: 1px solid #ccc;
      border-radius: 10px;
      text-align: center;
    }
  }

  .el-dialog__wrapper {
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999 !important;
  }

  /deep/ .el-dialog {
    border-radius: 4px !important;
    position: relative;
  }

  /deep/ .el-carousel__indicators {
    padding-bottom: 200px;
  }

  /deep/ .el-carousel__arrow--left {
    left: 220px;
    top: 305px;
  }

  /deep/ .el-carousel__arrow {
    width: 60px;
    height: 60px;
  }

  /deep/ .el-carousel__arrow i {
    font-size: 20px;
  }

  /deep/ .el-carousel__arrow--right {
    right: 220px;
    top: 305px;
  }

  /deep/ .el-button--primary {
    background-color: rgb(53, 189, 178);
    border-color: rgb(53, 189, 178);
  }

  /deep/ .el-button--default:hover {
    background-color: #fff;
    border-color: rgb(53, 189, 178);
    color: rgb(53, 189, 178);
  }

  .dialog-tishi-class /deep/ .el-dialog__body {
    padding: 0 20px !important;
  }

  .dialog-tishi-class {
    .code {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content: space-around;

      img {
        width: 200px;
        height: 200px;
      }
    }

    p {
      text-align: center;
      margin-top: 10px;
    }

    a {
      color: #00bbad;
      text-decoration-line: none;
    }
  }
}

.opacity {
  width: 100%;
  height: 100vh;
  opacity: 0.64;
  background: #000000;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.form_content {
  width: 23.46rem;
  height: 35.29rem;
  background: #FFFFFF;
  border-radius: 1.43rem;
  position: fixed;
  left: calc(50% - 11.73rem);
  top: calc(50% - 17.645rem);
  padding: 1.15rem 1.43rem 1.65rem;
  box-sizing: border-box;
  z-index: 99999;
  display: flex;
  align-items: center;
  flex-direction: column;

  p {
    font-weight: 400;
    font-size: 1.15rem;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 1.29rem;
  }

  .form_item {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 1.29rem;

    span {
      font-weight: 400;
      font-size: 0.86rem;
      color: rgba(0,0,0,0.85);
    }

    span::after {
      content: '*';
      color: #D70000;
      margin-left: 0.2rem;
    }

    input {
      width: 100%;
      height: 2.73rem;
      background: #FFFFFF;
      border-radius: 0.57rem;
      border: 0.07rem solid #D3D3D3;
      margin-top: 0.57rem;
      padding: 0 0.5rem;
      box-sizing: border-box;
    }
  }

  .form_item1 {
    width: 100%;
    display: flex;
    flex-direction: column;

    span {
      font-weight: 400;
      font-size: 0.86rem;
      color: rgba(0,0,0,0.85);
    }

    textarea {
      width: 100%;
      height: 5.74rem;
      background: #FFFFFF;
      border-radius: 0.57rem;
      border: 0.07rem solid #D3D3D3;
      margin-top: 0.57rem;
      padding: 0.5rem;
      box-sizing: border-box;
    }
  }

  .footer_box {
    width: 100%;
    margin-top: 1.59rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cencel {
      width: 9.76rem;
      height: 2.87rem;
      border-radius: 0.57rem;
      border: 0.07rem solid #CFCFCF;
      font-weight: 500;
      font-size: 1rem;
      color: rgba(0,0,0,0.65);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .sure {
      width: 9.76rem;
      height: 2.87rem;
      background: #31CEC2;
      border-radius: 0.57rem;
      font-weight: 500;
      font-size: 1rem;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v-servicechat.vue